<template>
  <div class="tw-root min-h-screen bg-gradient-to-br from-slate-50 to-violet-50">
    <header class="border-b border-slate-200 bg-white/70 backdrop-blur">
      <div :class="['mx-auto px-5 py-4 flex items-center gap-2', wide ? 'max-w-7xl' : 'max-w-3xl']">
        <span class="font-bold tracking-wide text-slate-800">NEWTV GENERATION</span>
        <span class="ml-auto text-xs text-slate-400">İçerik Portalı</span>
      </div>
    </header>

    <main :class="['mx-auto px-5 py-8', wide ? 'max-w-7xl' : 'max-w-3xl']">
      <router-view></router-view>
    </main>

    <footer :class="['mx-auto px-5 py-8 text-center text-xs text-slate-400', wide ? 'max-w-7xl' : 'max-w-3xl']">
      © {{ year }} FantasLink — NewTV
    </footer>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-property-decorator";
import "./tailwind.css";

@Component
export default class ContentPublicLayout extends Vue {
  year = new Date().getFullYear();

  // Ajans paneli influencer tablosu ve marka raporu tam genişlik;
  // diğer portallar dar kalır.
  get wide(): boolean {
    const path = this.$route.path || "";
    return path.startsWith("/agency") || path.startsWith("/brand");
  }
}
</script>
